import { jsx as _jsx } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { getLocalTimeZone, today } from '@internationalized/date';
import { useCalendarCell } from '@react-aria/calendar';
import { useRef } from 'react';
const CalendarCell = ({ state, date }) => {
    const calendarCellRef = useRef(null);
    const { cellProps, buttonProps: cellButtonProps, isSelected, isOutsideVisibleRange, isDisabled, formattedDate, } = useCalendarCell({ date }, state, calendarCellRef);
    const todayDate = today(getLocalTimeZone());
    const isToday = date.day === todayDate.day && date.month === todayDate.month && date.year === todayDate.year;
    return (_jsx("td", { className: "px-0.5 py-1", ...cellProps, children: _jsx("div", { ...cellButtonProps, className: buildClassName('skyline-text-body-2 flex h-6 w-6 items-center justify-center rounded-full text-black', 'hover:bg-primary-blue/10 focus-visible:bg-primary-blue/10 focus-visible:outline-0', {
                'text-primary-blue border border-solid': isToday,
                'text-black/20 hover:bg-transparent': isDisabled,
                hidden: isOutsideVisibleRange,
                'bg-primary-blue hover:bg-primary-blue focus-visible:bg-primary-blue text-white': isSelected && !isDisabled,
            }), ref: calendarCellRef, hidden: isOutsideVisibleRange, children: formattedDate }) }));
};
export default CalendarCell;
//# sourceMappingURL=CalendarCell.js.map